const handlePdRedirect = (pdRedirect) => {
  return () => {
    const customersURL = decodeURIComponent(pdRedirect).replace('reports', 'customers');
    window.location = customersURL;
  };
};

export default handlePdRedirect;
